export const ACCOUNT_OVERVIEW_REQUEST =
  'InvestorDashboardPage/ACCOUNT_OVERVIEW_REQUEST';
export const ACCOUNT_OVERVIEW_SUCCESS =
  'InvestorDashboardPage/ACCOUNT_OVERVIEW_SUCCESS';
export const ACCOUNT_OVERVIEW_ERROR =
  'InvestorDashboardPage/ACCOUNT_OVERVIEW_ERROR';
